<template>
  <div class="hamburger-menu">
    <div class="menu-items">
      <ul>
        <li>
          <button @click="goHome">Home</button>
        </li>
        <li>
          <button @click="gotoContact">Contact Info</button>
          <p class="menu-description">
            Where we can reach you regarding your pickups
          </p>
        </li>
        <li>
          <button @click="gotoDealer">Dealer</button>
          <p class="menu-description">
            Select your Revolution Plastics dealer to access region-specific
            programs and features
          </p>
        </li>
        <!-- <li>
          <button @click="gotoIdentities">Linked Accounts</button> //Auth0 popup for linking doesn't work in mobile browsers at this time
          <span class="menu-description"
            >Link your accounts to access additional login options or retrieve past data</span
          >
        </li> -->
        <template v-if="props.isAdmin">
          <li>
            <button class="admin" @click="gotoValidationAdmin">
              User Search
            </button>
          </li>
          <li>
            <button class="admin" @click="gotoAuth0Admin">
              Merge Accounts
            </button>
          </li>
          <li>
            <button class="admin" @click="gotoDealersAdmin">Dealers</button>
          </li>
        </template>
        <li v-if="callbackUrl">
          <button @click="logout">Logout</button>
        </li>
        <li>
          <button class="delete-account" @click="openAccOptionsModal">
            Delete Account
          </button>
        </li>
      </ul>
    </div>
  </div>
  <Modal
    :isOpen="accOptionsModalVisible"
    @update:isOpen="closeAccOptionsModal"
    :closeButton="true"
  >
    <div class="other-account-options-wrapper">
      <OtherAccountOptions
        v-if="!isNested"
        :verificationValue="verificationValue"
      />
    </div>
  </Modal>
</template>
<script setup>
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuth0 } from "@auth0/auth0-vue";
import Modal from "./Modal.vue";
import OtherAccountOptions from "./OtherAccountOptions.vue";

const $auth0 = useAuth0();
const router = useRouter();

const callbackUrl = ref(null);
const accOptionsModalVisible = ref(false);

const props = defineProps({
  isAdmin: { type: Boolean, default: false },
  onClose: { type: Function, default: () => {} },
});

onMounted(() => {
  const split = window.location.href.split("?");
  if (split.length <= 1) {
    callbackUrl.value = null;
    return;
  }

  const paramString = split[1];
  let params = new URLSearchParams(paramString);
  for (let pair of params.entries()) {
    if (pair[0] === "callback") {
      callbackUrl.value = pair[1];
    } else {
      callbackUrl.value = null;
    }
  }
});

const callbackQuery = computed(() => {
  return callbackUrl.value ? { callback: callbackUrl.value } : {};
});

const rawJson = computed(() => $auth0?.user?.value?.rawJson || {});

const verificationValue = computed(() => {
  const isMobileUser = $auth0?.user?.value?.rawJson?.user_id.includes("sms");
  if (isMobileUser) {
    return rawJson.value?.phone_number.slice(2);
  }
  return rawJson.value?.email;
});

function close() {
  props?.onClose();
}

function goHome() {
  router.push({ path: "/", query: callbackQuery.value });
  close();
}

function gotoContact() {
  router.push({ path: "/contact", query: callbackQuery.value });
  close();
}

function gotoDealer() {
  router.push({ path: "/dealer", query: callbackQuery.value });
  close();
}

// function gotoIdentities() {
//   router.push({ path: "/identities", query: callbackQuery.value });
//   close()
// }

function gotoValidationAdmin() {
  router.push({ path: "/validation-admin", query: callbackQuery.value });
  close();
}

function gotoAuth0Admin() {
  router.push({ path: "/auth0-admin", query: callbackQuery.value });
  close();
}

function gotoDealersAdmin() {
  router.push({ path: "/dealers-admin", query: callbackQuery.value });
  close();
}

function logout() {
  $auth0.logout({
    logoutParams: {
      returnTo: window.location.origin,
    },
  });
}

function openAccOptionsModal() {
  accOptionsModalVisible.value = true;
}

function closeAccOptionsModal() {
  accOptionsModalVisible.value = false;
}
</script>
<style lang="css" scoped>
.hamburger-menu {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-self: stretch;
  flex-grow: 1;
}

/* Hamburger Icon */
.hamburger-icon {
  position: relative;
  cursor: pointer;
  min-width: 4rem;
  z-index: 11;
}
.hamburger-icon span {
  font-size: 2rem;
}

/* Menu Items */
.menu-items {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
  align-items: center;
  align-items: center;
  width: 100%;
  animation: fadeIn 0.3s ease;
  z-index: 10;
}
.menu-items ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-items li {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 0;
}
.menu-items button {
  background-color: var(--bg1);
  color: var(--fg0);
  border: none;
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  margin: 0 1rem;
}
.menu-description {
  font-size: 0.85rem;
  color: #777;
  margin: 0 var(--padding);
  line-height: 1.2;
}
.admin {
  color: #f27935 !important;
}
.delete-account {
  color: rgba(218, 55, 55, 0.884) !important;
}
/* Fade-in Animation */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
